<template>
  <b-tooltip
    v-if="canShow"
    :label="$t('Orders.tooltipOp9')"
    type="is-dark"
  >
    <b-button
      icon-right="close-circle"
      class="local-lm-btn-row local-lm-block-action"
      @click.prevent="callActions(supplierOrderID, modalActions)"
    />
  </b-tooltip>
</template>

<script>
export default {
  name: 'BtnRejectOrder',
  props: {
    actions: Object
  },
  computed: {
    supplierOrderID () {
      return this.$attrs.id
    },
    supplierOrderCode () {
      return this.$attrs.supplierOrderCode
    },
    modalActions () {
      return this.actions.reject
    },
    canShow () {
      const inicio = new Date(this.$attrs.deadlineForReject)
      const now = new Date(Date.now())
      const diff = inicio - now

      return diff > 0
    }
  },
  methods: {
    callActions (order, type) {
      const parsedSupplierOrderCode = parseInt(this.supplierOrderCode)

      const orders = [{
        id: order,
        supplierOrderCode: !isNaN(parsedSupplierOrderCode) ? parsedSupplierOrderCode : ''
      }]

      const data = {
        orders,
        type
      }

      this.$store.dispatch('modal/launchModalWithData', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/miscellaneous/BtnRejectOrder.vue